export const EMOTION_SET = {
  'pleasure': '기쁨',
  'aversion': '혐오',
  'fear': '공포',
  'surprised': '놀람',
  'anger': '분노',
  'ache': '통증',
  'interest': '흥미',
  'boring': '지루',
  'sadness': '슬픔',
  'etc': '기타'
}